import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import CarrierLogisticsCommonsProvider from '@amzn/carrierlogistics-commons/dist/CarrierLogisticsCommonsProvider';
import CLWSCallerApp from '@amzn/carrier-logistics-common-ui-assets/dist/CLWSCallerApp';
import SlideOutSheet from '@amzn/carrier-logistics-inline-help-ui-assets/dist/SlideOutSheet';
import App from '../components/App';
import updateCSRFToken from '../utils/updateCSRFToken';
import { isAuthorizedPage } from '../utils/authorizedPageUtils';
import { HOME } from '../config/navigationalRoutes';

export default function Root({ store, history }) {
  useEffect(() => {
    // extracting csrf token set by MONS and saving it in the session, if present
    updateCSRFToken();
  }, []);
  return (
    <Provider store={store}>
      <div className="passport-app-root">
        <ConnectedRouter history={history}>
          <SlideOutSheet />
          <CarrierLogisticsCommonsProvider
            CLWSCaller={CLWSCallerApp}
            isPageAuthorized={isAuthorizedPage}
          >
            <Route path={HOME} component={App} />
          </CarrierLogisticsCommonsProvider>
        </ConnectedRouter>
      </div>
    </Provider>
  );
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
